// extracted by mini-css-extract-plugin
export var table = "_y5-0";